export const SET_UP_PASSWORD_EVENTS = { 
    VIEW_PROTECTION_MESSAGE_AFTER_LOGIN: "view_protection_message_after_login",
    SELECT_SET_UP_PASSWORD: "select_set_up_password",
    VIEW_SET_UP_PASSWORD_SCREEN: "view_set_up_password_screen",
    SELECT_SEND_CODE_SET_UP_PASSWORD: "select_send_code_set_up_password",
    SELECT_CREATE_PASSWORD: "select_create_password",
    VIEW_PASSWORD_SET_UP_DONE_GO_HOME_SCREEN: "view_password_set_up_done_go_home_screen",
    VIEW_PASSWORD_SET_UP_DONE_GO_ONBOARDING_SCREEN: "view_password_set_up_done_go_onboarding_screen"
} as const;